<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wX8SFQ/tc-custom/9781609251437.jpg?1705766050670" alt="This image is the cover for the book Q.B.L."/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Q.B.L.
      </h1>
      <p class="bookDescription body article font2">
        <p>Q.B.L. is a unique work in both Qabalah and Thelemic circles. In the world of the Qabalah, Frater Achad revealed revolutionary new principles that caused students of the Qabalah to reexamine and thus deepen their knowledge of the Tree of Life. In Thelemic circles, Aleister Crowley named Frater Achad his magical heir and Achad was fully expected to lead the cause of Thelemic Magick after Crowley's death--until publication of this book caused a rift between the two and Crowley began to distance himself from Achad. This is a rare and valuable book, both for its insight and circumstances. True understanding of the Qabalah and its benefit in magical practice is clearly described, and the information contained is both practical and revelatory. The circumstances surrounding it--Frater Achad's falling out with Crowley and eventual descent into apparent insanity--prove a valuable lesson and warning for individual seekers and those associated with established mystery schools.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frater Achad, Lon Milo DuQuette
      </h2>
      
      <p class="authorDescription body article">Lon Milo DuQuette is the author of 17 books that have been translated into 12 languages. He is also an award-winning singer-songwriter and recording artist whose musical career has spanned over 50 years. Lon is also an internationally recognized authority on tarot, Qabalah, and ceremonial magick and has written extensively about the life and work of Aleister Crowley. He is currently the US Deputy Grand Master of Ordo Templi Orientis.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Weiser Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?704ccb4c